import { ReportSummaryPanel } from "@/features/report/summary/ReportSummaryPanel"

export function ReportPage() {
    return (
        <ReportSummaryPanel />
    )
}